import { useState, useEffect } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { SelectType, ModifierByType } from "./common";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function EditPromotion({ open, onClose, promotion, updatePromotion }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    setState(promotion);
  }, [promotion]);
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const handleDateChange = (e) => {
    setState({
      ...state,
      expiration_date: e,
    });
  };
  const handleSubmit = () => {
    updatePromotion({
      ...state,
      expiration_date: new Date(state.expiration_date)
        .toISOString()
        .split(".")[0],
    });
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose} onSubmit={handleSubmit}>
      <div className="m-4">
        {state && (
          <div className="flex flex-col gap-4">
            <div className="">
              <input
                id="code"
                type="text"
                disabled
                onChange={handleChange}
                value={state.discount_identifier}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-400 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
            <div className="flex gap-4">
              <SelectType
                onChange={handleChange}
                value={state.discount_type}
                name="discount_type"
              />
              <ModifierByType
                type={state.discount_type}
                onChange={handleChange}
                value={state.discount_modifier}
                id="discount_modifier"
                name="discount_modifier"
              />
            </div>
            <div>
              <input
                id="message"
                name="message"
                type="text"
                onChange={handleChange}
                value={state.message}
                placeholder="message"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
            <div>
              <DatePicker
                onChange={handleDateChange}
                selected={state.expiration_date}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
function Modal({ open, onClose, onSubmit, children }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <DialogTitle
              as="h3"
              className="text-base font-semibold text-gray-900"
            >
              Edit Promotional Code
            </DialogTitle>
            {children}
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                onClick={onSubmit}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
              >
                Submit
              </button>
              <button
                type="button"
                data-autofocus
                onClick={onClose}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
export default EditPromotion;
